export default {
  props: {
    loading: Boolean
  }
};